<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";

const store = useStore();
const { isCutout, action, prefix } = defineProps<Props>();

const dimensions = computed(() => store.getters.getMeasurements( 'kite', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const width = computed({
	get: () => dimensions.value.width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});

const heightTop = computed({
	get: () => dimensions.value.height_top,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height_top",
			value: value,
		});
	},
});

const heightBottom = computed({
	get: () => dimensions.value.height_bottom,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height_bottom",
			value: value,
		});
	},
});

</script>
<template>
	<shape-input-fields-wrapper>
		<dimension-input
			inputRef="kite-height_top"
			:id="`${prefix}measurements-kite-height_top`"
			:name="`${prefix}measurements[dimensions][height_top]`"
			unit="cm"
			:label="dimensionLabel('height_top', 'kite')"
			:instructions="isCutout ? '' : dimensionMaxLabel('height_top')"
			:invalid="!isDimensionValid(`${prefix}kite-height_top`)"
			:onBlur="() => addSizeToDataLayer('height_top', +heightTop, 'kite')"
			v-model="heightTop"
		/>
		<dimension-input
			inputRef="kite-height_bottom"
			:id="`${prefix}measurements-kite-height_bottom`"
			:name="`${prefix}measurements[dimensions][height_bottom]`"
			unit="cm"
			:label="dimensionLabel('height_bottom', 'kite')"
			:instructions="isCutout ? '' : dimensionMaxLabel('height_bottom')"
			:invalid="!isDimensionValid(`${prefix}kite-height_bottom`)"
			:onBlur="() => addSizeToDataLayer('height_bottom', +heightBottom, 'kite')"
			v-model="heightBottom"
		/>
		<dimension-input
			inputRef="kite-width"
			:id="`${prefix}measurements-kite-width`"
			:name="`${prefix}measurements[dimensions][width]`"
			unit="cm"
			:label="dimensionLabel('width', 'kite')"
			:instructions="isCutout ? '' : dimensionMaxLabel('width')"
			:invalid="!isDimensionValid(`${prefix}kite-width`)"
			:onBlur="() => addSizeToDataLayer('width', +width, 'kite')"
			v-model="width"
		/>
	</shape-input-fields-wrapper>
</template>
